/**
 * @module video/videostyle
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import VideoStyleEditing from './videostyle/videostyleediting';
import VideoStyleUI from './videostyle/videostyleui';
export default class VideoStyle extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [VideoStyleEditing, VideoStyleUI];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoStyle';
    }
}
//# sourceMappingURL=videostyle.js.map